// extracted by mini-css-extract-plugin
export default {"productService":"productservice_productService__XmfQB","left":"productservice_left__WP8-i","right":"productservice_right__ID48p","active":"productservice_active__r2bmW"};